import { use } from 'i18next/dist/commonjs';
import AuthenticationService from './AuthenticationService';

 export function getDateValue(eventDate, options){
      return new  Date(eventDate.startDate).toLocaleDateString('de-DE', options)
   }

   export function  getTimeValue(eventDate){
    return (eventDate.startTime? (' ' + eventDate.startTime): ' ? ' ) + (eventDate.endTime ? (' - '+eventDate.endTime): '');
 }

 export function getDateDisplayValue(date, options){
   return new  Date(date).toLocaleDateString('de-DE', options)
}

export function getDatesDisplayValue(startDate, endDate, sameDay, lang){
   var full_options = { weekday: 'short', day: 'numeric', month: 'short', year: '2-digit' , hour:'numeric', minute:'numeric'};
   var hour_options = { hour:'numeric', minute:'numeric'};
   if(!startDate && !endDate){
     return "?"
   }
   if (startDate  && !endDate) {
        return getDateDisplayValue(startDate, full_options);
   }
   if (!startDate  && endDate) {
        return "? -" + getDateDisplayValue(endDate, full_options);
   }
   if (sameDay) {
     return  getDateDisplayValue(startDate, full_options) + " - "+   new  Date(endDate).toLocaleTimeString(lang, hour_options)
    }
     return  getDateDisplayValue(startDate, full_options) + " - " + getDateDisplayValue(endDate, full_options);
 }

 export function sameDay(start, end){
   return start && end && new Date(start).toDateString() === new Date(end).toDateString();
 }

 export function validateDate(start, end){
     if (start  && end) {
         return new Date(start).getTime() < new Date(end).getTime();
     }
     return start && new Date(start).getTime() > 0;
   }

   export function  getTransValue(value, lang){
    if('en' === lang){
      return value.en;
    }
    if('fr' === lang){
     return value.fr;
   }    
   return value.de;
 }

 export function  isEditable(creationUserId){
  let user = AuthenticationService.getLoggedUser();
    if(!user){
      return false;
    }
    return creationUserId === user.id || AuthenticationService.isUserInAdminRole();
}

export function getLocationDisplay(data, countries ){
  if(!data){
    return "";
  }
  let location = "";
  if(data.street && data.street.length > 0){
    location += data.street;
  }
  if(data.zipcode && data.zipcode.length > 0){
    location += " "+ data.zipcode;
  }
  if(data.country && data.country.length > 0){
    location += " "+ countries[data.country.trim()];
  }
  return location;
}


 

